module.exports = __webpack_public_path__ + "img/Edit_icon.159498ad.svg";